import { render, staticRenderFns } from "./MobileVerified.vue?vue&type=template&id=2bb61af1"
import script from "./MobileVerified.vue?vue&type=script&lang=js"
export * from "./MobileVerified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports